(function () {
  'use strict';

  var MENU_HEIGHT = 32;
  var sectionCleanups = new WeakMap();

  function getHeaderOffset() {
    var topBar = document.querySelector('#oa-hdr19 .oa-hdr19-top');
    if (topBar) {
      return Math.max(0, Math.round(topBar.getBoundingClientRect().bottom));
    }

    var header = document.getElementById('oa-hdr19');
    if (header) {
      return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }

    return 56;
  }

  function findTarget(anchorId) {
    if (!anchorId) return null;
    return (
      document.querySelector('[data-ls-anchor="' + anchorId + '"]') ||
      document.getElementById(anchorId)
    );
  }

  function getScrollOffset() {
    return getHeaderOffset() + MENU_HEIGHT;
  }

  function syncStickyOffset(section) {
    var offset = getHeaderOffset();
    section.style.setProperty('--ls-sticky-offset', offset + 'px');
    section.style.top = offset + 'px';
    document.documentElement.style.setProperty('--ls-sticky-anchor-scroll-padding', offset + MENU_HEIGHT + 'px');
  }

  function ensureSectionStacking(section) {
    var wrapper = section.closest('.ls-sticky-anchor-menu-section');
    if (!wrapper) return;

    wrapper.style.zIndex = '1000';
    wrapper.style.position = 'relative';
  }

  function pinSolidHeader() {
    var header = document.getElementById('oa-hdr19');
    var pageContent = document.querySelector('.oa-content');

    if (header) header.classList.remove('oa-hdr19--transparent');
    if (pageContent) pageContent.classList.remove('oa-content--transparent-header');

    if (window.oaHeader && typeof window.oaHeader.disableTransparency === 'function') {
      window.oaHeader.disableTransparency();
    }
  }

  function watchSolidHeader() {
    var header = document.getElementById('oa-hdr19');
    if (!header || typeof MutationObserver === 'undefined') return null;

    var headerObserver = new MutationObserver(function () {
      if (header.classList.contains('oa-hdr19--transparent')) {
        pinSolidHeader();
      }
    });

    headerObserver.observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });

    return headerObserver;
  }

  function setActiveLink(section, activeLink) {
    var activeLinkChanged = false;

    section.querySelectorAll('[data-ls-sticky-anchor-link]').forEach(function (link) {
      var isActive = link === activeLink;
      if (isActive !== link.classList.contains('is-active')) {
        activeLinkChanged = true;
      }
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    return activeLinkChanged;
  }

  function syncActiveLinkFromViewport(section) {
    var links = Array.prototype.slice.call(
      section.querySelectorAll('[data-ls-sticky-anchor-link]')
    );
    var targets = links
      .map(function (link) {
        var target = findTarget(link.getAttribute('data-anchor-id'));
        return target ? { link: link, target: target } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    var viewportTop = Math.min(getScrollOffset(), window.innerHeight);
    var viewportBottom = window.innerHeight;
    var availableHeight = Math.max(1, viewportBottom - viewportTop);
    var viewportCenter = viewportTop + availableHeight / 2;
    var bestTarget = null;
    var bestRatio = -1;
    var bestVisibleHeight = -1;
    var bestCenterDistance = Infinity;

    targets.forEach(function (entry) {
      var rect = entry.target.getBoundingClientRect();
      var visibleHeight = Math.max(
        0,
        Math.min(rect.bottom, viewportBottom) - Math.max(rect.top, viewportTop)
      );
      var maximumVisibleHeight = Math.max(1, Math.min(rect.height, availableHeight));
      var visibleRatio = visibleHeight / maximumVisibleHeight;
      var centerDistance = Math.abs((rect.top + rect.bottom) / 2 - viewportCenter);
      var hasBetterRatio = visibleRatio > bestRatio + 0.001;
      var hasEqualRatio = Math.abs(visibleRatio - bestRatio) <= 0.001;
      var hasMoreVisibleContent = visibleHeight > bestVisibleHeight + 1;
      var hasEqualVisibleContent = Math.abs(visibleHeight - bestVisibleHeight) <= 1;

      if (
        hasBetterRatio ||
        (hasEqualRatio && hasMoreVisibleContent) ||
        (hasEqualRatio && hasEqualVisibleContent && centerDistance < bestCenterDistance)
      ) {
        bestTarget = entry;
        bestRatio = visibleRatio;
        bestVisibleHeight = visibleHeight;
        bestCenterDistance = centerDistance;
      }
    });

    if (bestVisibleHeight <= 0) {
      bestTarget = targets[0];
      targets.forEach(function (entry) {
        if (entry.target.getBoundingClientRect().top <= viewportTop + 1) {
          bestTarget = entry;
        }
      });
    }

    if (bestTarget && setActiveLink(section, bestTarget.link)) {
      scrollLinkIntoView(bestTarget.link);
    }
  }

  function scrollLinkIntoView(link) {
    if (!link || !link.parentElement) return;

    var scrollContainer = link.closest('.ls-sticky-anchor-menu__scroll');
    if (!scrollContainer || scrollContainer.scrollWidth <= scrollContainer.clientWidth) return;

    var linkRect = link.getBoundingClientRect();
    var containerRect = scrollContainer.getBoundingClientRect();
    var delta = 0;

    if (linkRect.left < containerRect.left) {
      delta = linkRect.left - containerRect.left - 16;
    } else if (linkRect.right > containerRect.right) {
      delta = linkRect.right - containerRect.right + 16;
    }

    if (delta !== 0) {
      scrollContainer.scrollBy({ left: delta, behavior: 'smooth' });
    }
  }

  function scrollToAnchor(anchorId) {
    var target = findTarget(anchorId);
    if (!target) return;

    var top = window.scrollY + target.getBoundingClientRect().top - getScrollOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  // The href has to resolve to a real element, not just to data-ls-anchor. Most target
  // sections already carry their own id, so the anchor id is stamped only when one has none.
  function resolveLinkTargets(section) {
    section.querySelectorAll('[data-ls-sticky-anchor-link]').forEach(function (link) {
      var anchorId = link.getAttribute('data-anchor-id');
      var target = findTarget(anchorId);
      if (!target) return;
      if (!target.id) target.id = anchorId;
      link.setAttribute('href', '#' + target.id);
    });
  }

  function initializeSection(section) {
    if (!section || section.dataset.lsStickyAnchorReady === 'true') return;
    section.dataset.lsStickyAnchorReady = 'true';
    resolveLinkTargets(section);

    var resizeTimer;
    var viewportSyncFrame;
    var syncStickyOnNextFrame = false;
    var headerResizeObserver;
    var headerMutationObserver;

    function scheduleViewportSync(includeStickyOffset) {
      if (includeStickyOffset) {
        syncStickyOnNextFrame = true;
      }
      if (viewportSyncFrame) return;

      viewportSyncFrame = window.requestAnimationFrame(function () {
        viewportSyncFrame = null;
        if (syncStickyOnNextFrame) {
          syncStickyOnNextFrame = false;
          syncStickyOffset(section);
        }
        syncActiveLinkFromViewport(section);
      });
    }

    function refreshLayout() {
      syncStickyOffset(section);
      ensureSectionStacking(section);
      scheduleViewportSync(false);
    }

    function handleClick(event) {
      var link = event.target.closest('[data-ls-sticky-anchor-link]');
      if (!link || !section.contains(link)) return;

      event.preventDefault();
      setActiveLink(section, link);
      scrollLinkIntoView(link);
      scrollToAnchor(link.getAttribute('data-anchor-id'));
    }

    function handleScroll() {
      scheduleViewportSync(true);
    }

    function handleResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refreshLayout, 100);
    }

    section.addEventListener('click', handleClick);

    refreshLayout();
    pinSolidHeader();
    headerMutationObserver = watchSolidHeader();

    window.addEventListener('scroll', handleScroll, { passive: true });

    var header = document.getElementById('oa-hdr19');
    if (header && typeof ResizeObserver !== 'undefined') {
      headerResizeObserver = new ResizeObserver(function () {
        refreshLayout();
      });
      headerResizeObserver.observe(header);
    }

    window.addEventListener('resize', handleResize);

    sectionCleanups.set(section, function () {
      section.removeEventListener('click', handleClick);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      window.clearTimeout(resizeTimer);

      if (viewportSyncFrame) {
        window.cancelAnimationFrame(viewportSyncFrame);
      }
      if (headerResizeObserver) {
        headerResizeObserver.disconnect();
      }
      if (headerMutationObserver) {
        headerMutationObserver.disconnect();
      }

      delete section.dataset.lsStickyAnchorReady;
      sectionCleanups.delete(section);
    });
  }

  function cleanupSection(section) {
    var cleanup = sectionCleanups.get(section);
    if (cleanup) cleanup();
  }

  function initializeAll(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.matches('[data-ls-sticky-anchor-menu]')) {
      initializeSection(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll('[data-ls-sticky-anchor-menu]').forEach(initializeSection);
    }
  }

  function cleanupAll(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.matches('[data-ls-sticky-anchor-menu]')) {
      cleanupSection(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll('[data-ls-sticky-anchor-menu]').forEach(cleanupSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      pinSolidHeader();
      initializeAll(document);
    });
  } else {
    pinSolidHeader();
    initializeAll(document);
  }

  document.addEventListener('DOMContentLoaded', pinSolidHeader);

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupAll(event.target);
  });
})();
